import Collapsable from "components/Collapsable";
import Content from "components/Content";
import Label from "components/Label";
import React, { FC } from "react";
import { BsFillCheckCircleFill as CircularCheck } from "react-icons/bs";

import styles from "./styles.module.scss";

interface Props {
  what_you_get: {
    title: string;
    services: { title: string; description: string; includes: string[] }[];
  };
}

const WhatYouGet: FC<Props> = ({ what_you_get: whatYouGet }) => {
  return (
    <Content
      containerClassName={styles.wrapper}
      contentClassName={styles.container}
    >
      <div className={styles.bottom}>
        <Label
          variant="h-centered"
          color="white"
          className={styles.bottomTitle}
        >
          {whatYouGet.title}
        </Label>
        <div className={styles.services}>
          {whatYouGet.services.map(({ title, description, includes }) => (
            <Collapsable
              key={title}
              className={styles.collapsable}
              withIcon
              headerClassName={styles.collapsableHeader}
              iconClassName={styles.collapsableIcon}
              header={
                <div className={styles.headerWrapper}>
                  <Label
                    className={styles.collapsableHeaderLabel}
                    color="white"
                    variant="h"
                  >
                    {title}
                  </Label>
                  <Label
                    className={styles.serviceDescription}
                    color="white"
                    variant="s"
                  >
                    {description}
                  </Label>
                </div>
              }
            >
              <div className={styles.includes}>
                {includes.map((item) => (
                  <div className={styles.included} key={item}>
                    <CircularCheck className={styles.check} />
                    <Label className={styles.item} color="white" variant="s">
                      {item}
                    </Label>
                  </div>
                ))}
              </div>
            </Collapsable>
          ))}
        </div>
      </div>
    </Content>
  );
};

export default WhatYouGet;
